var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan21 = function SvgDAhuSignalFan21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 54,
    width: 89,
    height: 2,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 56,
    width: 2,
    height: 42,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407 198 405 198 405 160.01 430 160.01 430 114 432 114 432 162.01 407 162.01 407 198",
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 210,
    width: 2,
    height: 106,
    fill: "#1c9d5b"
  }))));
};
export default SvgDAhuSignalFan21;